// import pdfMake from 'pdfmake/build/pdfmake'
// import pdfFonts from 'pdfmake/build/vfs_fonts'
// pdfMake.vfs = pdfFonts.pdfMake.vfs
import jsPDF from 'jspdf'
import 'jspdf-autotable'
import firebaseService from './firebase'
import QRCode from 'qrcode'

export default {
  printLabel,
  printOfficeCopy,
  printInstallerCopy
}

async function printLabel (projectInfo, userInfo, items, directDownload) {
  try {
    console.log(projectInfo, userInfo)
    saveLabelSheet(projectInfo, userInfo, items, directDownload)

    return {
      success: true,
      error: null
    }
  } catch (error) {
    return {
      success: false,
      error: error
    }
  }
}

async function printOfficeCopy (projectInfo, userInfo, items, directDownload) {
  try {
    console.log(projectInfo, userInfo)
    saveOfficeCopy(projectInfo, userInfo, items, directDownload)

    return {
      success: true,
      error: null
    }
  } catch (error) {
    return {
      success: false,
      error: error
    }
  }
}

async function printInstallerCopy (projectInfo, userInfo, items, directDownload) {
  try {
    console.log(projectInfo, userInfo)
    saveInstallerCopy(projectInfo, userInfo, items, directDownload)

    return {
      success: true,
      error: null
    }
  } catch (error) {
    console.log(error)
    return {
      success: false,
      error: error
    }
  }
}

/* below is helper functions */

function saveLabelSheet (projectInfo, userInfo, items, directDownload) {
  // parse items (Duplicate item whose qty>1)
  let labelsData = parseItemsToLabelsData(projectInfo, items)
  console.log(labelsData)
  // generate tables
  let labelTables = generateLabelTables(labelsData)
  console.log(labelTables)
  // generate jsPDF instance
  let labelSheet = generateLabelSheet(labelTables, projectInfo, userInfo)

  if (!directDownload) {
    labelSheet.output('dataurlnewwindow', { filename: 'test.pdf' })
  } else {
    labelSheet.save(`${projectInfo.name} - Label.pdf`)
  }
}

function parseItemsToLabelsData (projectInfo, items) {
  let parsedItems = []
  let currentTime = new Date()
  for (let i = 0; i < items.length; i++) {
    let multiplier = getValue(items[i], 'qty') // multiply label based on its qty.
    let item = {
      QTY: getValue(items[i], 'qty'),
      RL: getValue(items[i], 'rl'),
      SM: projectInfo.sideMark || '',
      SIZE: getValue(items[i], 'size'),
      COLOR: getValue(items[i], 'color'),
      DATE: currentTime.toLocaleDateString('en-US'),
      PO: projectInfo.purchaseOrder || '',
      WO: projectInfo.workOrder || ''
    }
    while (multiplier > 0) {
      item.INDEX = item.QTY - multiplier + 1 // set current copy's index
      parsedItems.push(JSON.parse(JSON.stringify(item)))
      multiplier--
    }
  }
  return parsedItems
}

function generateLabel (data, index) {
  // add blank to the left col text in order to solve unclear margin
  let label = [
    [
      { content: ` RL: ${data.RL}`, colSpan: 5 },
      { content: `Date: ${data.DATE}`, colSpan: 5 },
      { content: ``, colSpan: 1, rowSpan: 6 }
    ],
    [
      { content: ` SM: ${data.SM}`, colSpan: 5 },
      { content: `PO: ${data.PO}`, colSpan: 5 }
    ],
    [
      { content: ` SZ: ${data.SIZE}`, colSpan: 10, styles: { fontStyle: `bold` } }
    ],
    [
      { content: ` WO: ${data.WO}`, colSpan: 10 }
    ],
    [
      { content: ` CR: ${data.COLOR}`, rowSpan: 2, colSpan: 8, styles: { valign: 'top' } },
      { content: `${index}`, rowSpan: 1, colSpan: 2, styles: { halign: 'right', valign: 'bottom' } }
    ],
    [
      { content: `--`, rowSpan: 1, colSpan: 2, styles: { halign: 'right', valign: 'bottom' } }
    ]
  ]
  return label
}

function generateLabelTables (labelsData) {
  let tables = [] // 1D array
  let table = [(new Array(33)).fill({ content: '___', styles: { textColor: 128 } })] // 10 rows per table, print table head
  let row = Array.from(Array(6), () => []) // 3 labels per row (6*X array => 6 lines per label)
  for (let i = 0; i < labelsData.length; i++) {
    let data = labelsData[i]
    let label = generateLabel(data, i + 1) // each label print 3 times

    // append the new label to the rows(print 3 times for each label)
    for (let j = 0; j < 6; j++) {
      // label must be appended to row one line by one line row[6*X] (x is dynamic)
      row[j] = row[j].concat(label[j]).concat(label[j]).concat(label[j])
    }
    // test if this row is full
    if (row[0].length === 9 || i === labelsData.length - 1) { // for each label, its first line is [1*3], so row will full if row[0].length === 9
      console.log('Add new Row')
      table = table.concat(JSON.parse(JSON.stringify(row))) // table [61*X] (full)
      row = Array.from(Array(6), () => []) // clear the row
    }
    // test if this table is full
    if (table.length === 61 || i === labelsData.length - 1) { // each table has 60 + 1（head） lines, table is a [60*33](FULL)
      tables.push(JSON.parse(JSON.stringify(table)))
      table = [(new Array(33)).fill({ content: '___', styles: { textColor: 128 } })] // clear table content
    }
  }
  // parse tables to AutoTables' obj format
  let tableObjects = tables.map((tableArray, index) => {
    return {
      theme: 'plain', // NOTE:change to 'plain' in product and 'grid' in dev(in case want to know the table's structure)
      startY: index === 0 ? 24 : 792 * index + 1,
      margin: { left: 16, top: 24, bottom: 0, right: 0 },
      pageBreak: 'avoid',
      // rowPageBreak: 'avoid',
      tableWidth: 594,
      styles: {
        cellWidth: 17.2,
        overflow: 'ellipsize',
        fontSize: 8,
        cellPadding: 0,
        minCellWidth: 17.2,
        minCellHeight: 12,
        valign: 'bottom'
      },
      body: tableArray,
      willDrawCell: data => {
        if (data.section === 'body' && data.row.index % 6 === 4) {
          var base64Icon = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAACXBIWXMAAAsTAAALEwEAmpwYAAAF+mlUWHRYTUw6Y29tLmFkb2JlLnhtcAAAAAAAPD94cGFja2V0IGJlZ2luPSLvu78iIGlkPSJXNU0wTXBDZWhpSHpyZVN6TlRjemtjOWQiPz4gPHg6eG1wbWV0YSB4bWxuczp4PSJhZG9iZTpuczptZXRhLyIgeDp4bXB0az0iQWRvYmUgWE1QIENvcmUgNS42LWMxNDUgNzkuMTYzNDk5LCAyMDE4LzA4LzEzLTE2OjQwOjIyICAgICAgICAiPiA8cmRmOlJERiB4bWxuczpyZGY9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkvMDIvMjItcmRmLXN5bnRheC1ucyMiPiA8cmRmOkRlc2NyaXB0aW9uIHJkZjphYm91dD0iIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtbG5zOmRjPSJodHRwOi8vcHVybC5vcmcvZGMvZWxlbWVudHMvMS4xLyIgeG1sbnM6cGhvdG9zaG9wPSJodHRwOi8vbnMuYWRvYmUuY29tL3Bob3Rvc2hvcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RFdnQ9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZUV2ZW50IyIgeG1wOkNyZWF0b3JUb29sPSJBZG9iZSBQaG90b3Nob3AgQ0MgMjAxOSAoV2luZG93cykiIHhtcDpDcmVhdGVEYXRlPSIyMDIwLTAyLTE4VDEwOjM0OjI1KzA4OjAwIiB4bXA6TW9kaWZ5RGF0ZT0iMjAyMC0wMi0xOFQxMDozNTozNCswODowMCIgeG1wOk1ldGFkYXRhRGF0ZT0iMjAyMC0wMi0xOFQxMDozNTozNCswODowMCIgZGM6Zm9ybWF0PSJpbWFnZS9wbmciIHBob3Rvc2hvcDpDb2xvck1vZGU9IjMiIHBob3Rvc2hvcDpJQ0NQcm9maWxlPSJzUkdCIElFQzYxOTY2LTIuMSIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDozNmU1NDYyMi1lOGEzLTEyNDUtYjk4Ny0yZTk3MzhjNTY4YWUiIHhtcE1NOkRvY3VtZW50SUQ9ImFkb2JlOmRvY2lkOnBob3Rvc2hvcDo0YTEzZTU0Ny1iZTQwLWFkNDYtYjY2Yi03YWZlZTY0NjQzZDkiIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDpjMzBkYzU4MS02ZGJmLWEwNGQtODk1NS1kYmJhMGVjNjMwNTgiPiA8eG1wTU06SGlzdG9yeT4gPHJkZjpTZXE+IDxyZGY6bGkgc3RFdnQ6YWN0aW9uPSJjcmVhdGVkIiBzdEV2dDppbnN0YW5jZUlEPSJ4bXAuaWlkOmMzMGRjNTgxLTZkYmYtYTA0ZC04OTU1LWRiYmEwZWM2MzA1OCIgc3RFdnQ6d2hlbj0iMjAyMC0wMi0xOFQxMDozNDoyNSswODowMCIgc3RFdnQ6c29mdHdhcmVBZ2VudD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTkgKFdpbmRvd3MpIi8+IDxyZGY6bGkgc3RFdnQ6YWN0aW9uPSJzYXZlZCIgc3RFdnQ6aW5zdGFuY2VJRD0ieG1wLmlpZDozNmU1NDYyMi1lOGEzLTEyNDUtYjk4Ny0yZTk3MzhjNTY4YWUiIHN0RXZ0OndoZW49IjIwMjAtMDItMThUMTA6MzU6MzQrMDg6MDAiIHN0RXZ0OnNvZnR3YXJlQWdlbnQ9IkFkb2JlIFBob3Rvc2hvcCBDQyAyMDE5IChXaW5kb3dzKSIgc3RFdnQ6Y2hhbmdlZD0iLyIvPiA8L3JkZjpTZXE+IDwveG1wTU06SGlzdG9yeT4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz5GUj42AAADNklEQVRYw+2WyWsUQRSHXy093dOZySRjDlERjQuIyVEFJTl48SLi1b9BcEE04kEQRAIeRAUFwZMeAl69eFEkEZcEkTiIWzITgmiCIWSS3qq7FqtmFLOYxGg0HubRRTVd9ep97/WvikJKKVhNQzWAGsB/A3DwyMllOd7pOo+KxVK+VBoGFkUT3Y+fLyuTezcu/z7A1dPH3DhOWnzf31AovIY4jkfS6XTp7pO+8K8CXD97koRhtFYIsUX71UdRBAMDBTA9xngqlbIGs9ns6O2HvWJFAbovXYDRsbFckvCtUspm7YPNd8ZYBSAMQ0AImSYIIaO2nRpqa2stn791+88BrnUeTzEWb9RZb9JznZljPwAiHfzHd12NkFI67Lrpke7eZ/FvAdw814k9z2/inG/TWTeauXMXWQjgmyldjQnzW/L5/Pit+w/kLwNcOXW0Totssw68Xo9bC5VxCYBqAIQSXY2PjmNrkfb7iwJcO3PCihlbx3lFZHVLCWmuBhYz/Vs8y6LFtOt+6u55mswDGCuW6BTnmxKpmhVCVBccVca1Lyjzrqp9VYAmHDLqf2UAokiPmKlQbQhJVOlBVpcwvXFE3LGsz2sbG0f2HzrAZwFM7uyol4xtB0qkStlCuQ5XritUJitlLiNkQ4OSuZyUDTml30Hm6iGyU/CuOAzh+ISkQQjUD4F4PiZ+gEjgY+xHmLCY4IgRFCcEeEKRVJg69vv2l4/KswFadjQpL9itQclcMc1oJjMjJrPPRUKwGMJpiAEZH9PwN/9q5arCRd+fygoYSeKm+9oH+7/MAWhtUoEGkPMAFrQEYxjCjgFYxuGvAercvvYPfSsEQDSAqgGsJsA/10D1FBCAcMwJCQaxrWIBrla//ZMdtAIAWAfDKNZHmd7keBphMgUW9ZDtBLCmkb1luhKTUynFhQtCZJQU9SBUVq9roFLzoBYE2Ny6RgXhLl1Nk10AFHuVYJR6YNs+yjcwuq9DHB4vL5pgF6bg9b8kvDxtq4S7IGVGCQ0lVaYCBfqoc9Mv5gGU23bZKmJZsK0Q5XKM7tnND4fxitz7LgYM/MIbIoLABi5d7DjTews9rHYrrgHUAIx9BQ8sc9/zgswaAAAAAElFTkSuQmCC'
          data.doc.addImage(base64Icon, 'PNG', data.cell.x + 144, data.cell.y, 24, 24)
        }
      },
      didDrawPage: data => {
        data.doc.totalPagesCounter = data.doc.totalPagesCounter + 1 || 1// add customer property to doc instance
      }
    }
  })

  return tableObjects
}

function generateLabelSheet (labelTables, projectInfo, userInfo) {
  // generate jsPDF instance

  let doc = new jsPDF({   // eslint-disable-line
    orientation: 'p',
    unit: 'pt',
    format: [612, 792], // letter
    floatPrecision: 'smart'
  })
  // add water mark on labels
  for (let tableObj of labelTables) {
    doc.autoTable(tableObj)
  }
  // add footer for each page
  let stamp = new Date()
  // let footer = `${projectInfo.name} - Exported By ${userInfo.name.first} ${userInfo.name.last} @ ${stamp.toLocaleString('en-US')} `
  doc.setFontSize(8)
  doc.setFontStyle('italic')
  for (let i = 1; i <= doc.totalPagesCounter; i++) {
    doc.setPage(i)
    doc.text(
      `[${projectInfo.name}]`,
      140, 20, // X, Y
      { align: 'left' }
    )
    doc.text(
      `[${i}/${doc.totalPagesCounter}]`,
      416, 20, // X, Y
      { align: 'left' }
    )
    doc.text(
      `[${userInfo.name.first} ${userInfo.name.last}]`,
      140, 770, // X, Y
      { align: 'left' }
    )
    doc.text(
      `[${stamp.toLocaleDateString('en-US')}]`,
      416, 770, // X, Y
      { align: 'left' }
    )
  }
  return doc
}

function getValue (item, field) {
  let question
  if (typeof item !== 'object') {
    throw new Error('Item is not available')
  }
  switch (field) {
    case 'width':
      question = item.detail.questions.find(q => {
        return q.id === 'numop_orderWidth'
      })
      if (!question) {
        return 'N/A'
      }
      return question.value.filter(value => value !== '').join('-')
    case 'height':
      question = item.detail.questions.find(q => {
        return q.id === 'numop_orderHeight'
      })
      if (!question) {
        return 'N/A'
      }
      return question.value.filter(value => value !== '').join('-') // join non-null width
    case 'mountType':
      question = item.detail.questions.find(q => {
        return q.id === 'radio_mountType'
      })
      if (!question) {
        return 'N/A'
      }
      return question.value || '_'
    case 'control':
      question = item.detail.questions.find(q => {
        return q.id === 'radio_control'
      })
      if (!question) {
        return 'N/A'
      }
      if (question.value === 'Left') {
        return 'L'
      } else if (question.value === 'Right') {
        return 'R'
      } else {
        return question.value || '_'
      }
    case 'specialColor':
      question = item.detail.questions.find(q => {
        return q.id === 'input_specialColor'
      })
      if (!question) {
        return 'N/A'
      }
      return question.value || '_'
    case 'modifiedDate':
      if (!item.detail.lastEditOn) {
        return 'N/A'
      }
      let date = new Date(item.detail.lastEditOn)
      return date.toLocaleDateString('en-US')
    case 'qty':
      return item.quantity || 0
    case 'index':
      return item.item
    case 'rl':
      return `${item.folder === 'No Folder' ? '' : item.folder + ' - '}${item.item} - ${item.mark}` // example output: Folder 1 - 4 - Special OR 4 - Special
    case 'size':
      return `${getValue(item, 'width')}×${getValue(item, 'height')} ${getValue(item, 'mountType')} ${getValue(item, 'control')}`
    case 'p':
      return getP(item)
    case 'operatingSystem':
      question = item.detail.questions.find(q => {
        return q.id === 'opwop_operatingSystem'
      })
      if (!question) {
        return 'N/A'
      }
      return `${question.value[0]}${question.value[1] ? '(' + question.value[1] + ')' : ''}`
    case 'fabricType':
      question = item.detail.questions.find(q => {
        return q.id === 'radio_fabricType'
      })
      if (!question) {
        return 'N/A'
      }
      return `${question.value}`
    case 'fabric':
      question = item.detail.questions.find(q => {
        return q.id === 'opwop_fabric'
      })
      if (!question) {
        return 'N/A'
      }
      return `${question.value[0]}${question.value[1] ? '(' + question.value[1] + ')' : ''}`
    case 'tilt':
      question = item.detail.questions.find(q => {
        return q.id === 'radio_tiltType'
      })
      if (!question) {
        return 'N/A'
      }
      return `${question.value}`
    case 'slats':
      question = item.detail.questions.find(q => {
        return q.id === 'radio_slatsType'
      })
      if (!question) {
        return 'N/A'
      }
      return `${question.value}`
    case 'color':
      question = item.detail.questions.find(q => {
        return q.id === 'input_color'
      })
      if (!question) {
        return 'N/A'
      }
      return `${question.value}`
    case 'vanes':
      question = item.detail.questions.find(q => {
        return q.id === 'input_vanes'
      })
      if (!question) {
        return 'N/A'
      }
      return `${question.value}`
    case 'productType':
      return item.detail.templateName || 'Custom'
    case 'productInfo':
      return `${getValue(item, 'productType')} - ${getValue(item, 'operatingSystem')}`
    case 'specialNote':
      question = item.detail.questions.find(q => {
        return q.id === 'input_specialNote'
      })
      if (!question) {
        return ''
      }
      return `${question.value}`
    case 'cost':
      return parseFloat(item.cost)
    case 'ext':
      return (parseFloat(item.cost) * (item.qty || 0))
    default:
      return 'Unknown Field'
  }
}

async function saveOfficeCopy (projectInfo, userInfo, items, directDownload) {
  // parse items data for use
  let necessaryFields = ['qty', 'rl', 'productInfo', 'size', 'fabric', 'specialNote', 'cost', 'ext']
  let subTotal = 0
  let parsedItems = items.map(item => {
    let parsedItem = {}
    for (let field of necessaryFields) {
      parsedItem[field] = getValue(item, field)
    }
    subTotal += parsedItem['ext']
    return parsedItem
  })

  let officeCopy = new jsPDF({   // eslint-disable-line
    orientation: 'p',
    unit: 'pt',
    format: 'letter' // letter(612x792pt) with v-margin = 36, h-margin = 36
  })
  officeCopy.totalPagesCounter = 1 // first page has no hook to auto add, so start count from 1

  // print company logo
  officeCopy.addImage(
    'data:image/png;base64,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',
    'PNG',
    36, 36,
    48, 48
  )
  // print company address
  officeCopy.autoTable({
    theme: 'plain',
    tableWidth: 'wrap',
    startY: 90,
    body: [
      [
        {
          content: '21st Century U.S.-Sino Services, Inc.',
          styles: {
            fontStyle: 'bold',
            cellPadding: 4
          }
        }
      ],
      [
        {
          content: '2463 S. Archer Ave.',
          styles: {
            cellPadding: 4
          }
        }
      ],
      [
        {
          content: 'Chicago IL 60616',
          styles: {
            cellPadding: 4
          }
        }
      ],
      [
        {
          content: 'Tel: (312)808-9328 / Fax: (312)808-9288',
          styles: {
            cellPadding: 4
          }
        }
      ],
      [
        {
          content: 'www.21centuryservice.com',
          styles: {
            cellPadding: 4
          }
        }
      ]
    ]
  })

  // print customer's address
  officeCopy.autoTable({
    startY: 24,
    theme: 'plain',
    margin: {
      left: 300,
      top: 0,
      bottom: 0,
      right: 36
    },
    body: [
      [
        {
          content: 'Ship To: ',
          styles: {
            fontStyle: 'bold',
            cellPadding: 2,
            halign: 'right'
          }
        },
        {
          content: `${projectInfo.shipTo}`,
          styles: {
            cellPadding: 2,
            halign: 'left'
          }
        }
      ],
      [
        {
          content: 'Company Name: ',
          styles: {
            fontStyle: 'bold',
            cellPadding: 2,
            halign: 'right',
            cellWidth: 'wrap'
          }
        },
        {
          content: `${projectInfo.companyName}`,
          styles: {
            cellPadding: 2,
            halign: 'left'
          }
        }
      ],
      [
        {
          content: 'Contact: ',
          styles: {
            fontStyle: 'bold',
            cellPadding: 2,
            halign: 'right'
          }
        },
        {
          content: `${projectInfo.contact}`,
          styles: {
            cellPadding: 2,
            halign: 'left'
          }
        }
      ],
      [
        {
          content: 'Street: ',
          styles: {
            fontStyle: 'bold',
            cellPadding: 2,
            halign: 'right'
          }
        },
        {
          content: `${projectInfo.street}Test Very Very Very Very Very Very Very Very Very Very Long Address`,
          styles: {
            cellPadding: 2,
            halign: 'left'
          }
        }
      ],
      [
        {
          content: 'City: ',
          styles: {
            fontStyle: 'bold',
            cellPadding: 2,
            halign: 'right'
          }
        },
        {
          content: `${projectInfo.city}`,
          styles: {
            cellPadding: 2,
            halign: 'left'
          }
        }
      ],
      [
        {
          content: 'State: ',
          styles: {
            fontStyle: 'bold',
            cellPadding: 2,
            halign: 'right'
          }
        },
        {
          content: `${projectInfo.state}`,
          styles: {
            cellPadding: 2,
            halign: 'left'
          }
        }
      ],
      [
        {
          content: 'Phone: ',
          styles: {
            fontStyle: 'bold',
            cellPadding: 2,
            halign: 'right'
          }
        },
        {
          content: `${projectInfo.phone}`,
          styles: {
            cellPadding: 2,
            halign: 'left'
          }
        }
      ],
      [
        {
          content: 'Zip: ',
          styles: {
            fontStyle: 'bold',
            cellPadding: 2,
            halign: 'right'
          }
        },
        {
          content: `${projectInfo.zip}`,
          styles: {
            cellPadding: 2,
            halign: 'left'
          }
        }
      ],
      [
        {
          content: 'Ship-Via: ',
          styles: {
            fontStyle: 'bold',
            cellPadding: 2,
            halign: 'right'
          }
        },
        {
          content: `${projectInfo.shipVia}`,
          styles: {
            cellPadding: 2,
            halign: 'left'
          }
        }
      ]
    ]
  })

  // print order Info
  let currentTime = new Date()
  officeCopy.autoTable({
    startY: 200,
    theme: 'striped',
    margin: {
      left: 36,
      top: 24,
      bottom: 24,
      right: 36
    },
    head: [
      ['QN', 'DATE', 'SM', 'PO']
    ],
    bodyStyle: {
      bold: true
    },
    body: [
      [
        `${projectInfo.qn || 'N/A'}`,
        `${currentTime.toLocaleDateString('en-US')}`,
        `${projectInfo.sideMark || 'N/A'}`,
        `${projectInfo.purchaseOrder || 'N/A'}`
      ]
    ]
  })

  // print item list
  for (let i = 0; i < parsedItems.length; i++) {
    officeCopy.autoTable({
      theme: 'grid',
      margin: {
        top: 0,
        bottom: 36,
        left: 48,
        right: 48
      },
      tableWidth: 540,
      styles: {
        cellWidth: 50,
        overflow: 'ellipsize',
        fontSize: 10,
        cellPadding: 2,
        minCellWidth: 53,
        minCellHeight: 12,
        valign: 'middle'
      },
      pageBreak: 'avoid',
      body: [
        Array.from(new Array(10), () => {
          return {
            content: ' ',
            cellWidth: 54,
            styles: {
              lineWidth: 0
            }
          }
        }),
        [
          { // Item index
            content: `${i + 1} / ${parsedItems.length}`,
            colSpan: 2,
            rowSpan: 2,
            styles: { fontSize: 18, valign: 'middle', halign: 'center' }
          },
          {
            // RL Title
            content: 'RL',
            colSpan: 1,
            rowSpan: 1,
            styles: { fontStyle: 'bold', halign: 'center' }
          },
          {
            // RL Content
            content: `${parsedItems[i].rl}`,
            colSpan: 3,
            rowSpan: 1
          },
          {
            // SZ Title
            content: 'SZ',
            colSpan: 1,
            rowSpan: 1,
            styles: { fontStyle: 'bold', halign: 'center' }
          },
          {
            // RL Content
            content: `${parsedItems[i].size}`,
            colSpan: 3,
            rowSpan: 1
          }
        ],
        [
          {
            // P Title
            content: 'Product',
            colSpan: 1,
            rowSpan: 1,
            styles: { fontStyle: 'bold', halign: 'center' }
          },
          {
            // P Content
            content: `${parsedItems[i].productInfo}`,
            colSpan: 7,
            rowSpan: 1
          }
        ],
        [
          {
            // Qty Title
            content: 'Qty.',
            colSpan: 1,
            rowSpan: 1,
            styles: { fontStyle: 'bold', halign: 'center' }
          },
          {
            // Qty Content
            content: `${parsedItems[i].qty}`,
            colSpan: 1,
            rowSpan: 1,
            styles: { halign: 'center' }
          },
          {
            // Fabric Title
            content: 'Fabric',
            colSpan: 1,
            rowSpan: 1,
            styles: { fontStyle: 'bold', halign: 'center' }
          },
          {
            // Fabric Content
            content: `${parsedItems[i].fabric}`,
            colSpan: 7,
            rowSpan: 1
          }
        ],
        [
          {
            // Cost
            content: `Cost: ${parsedItems[i].cost.toLocaleString('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 2, maximumFractionDigits: 2 })}`,
            colSpan: 2,
            rowSpan: 1,
            styles: { fontStyle: 'bold', halign: 'center' }
          },
          {
            // Special Note
            content: `Special Note: ${parsedItems[i].specialNote}`,
            colSpan: 8,
            rowSpan: 2,
            styles: { fontStyle: 'bold', valign: 'top' }
          }
        ],
        [
          {
            // Ext
            content: `Ext: ${parsedItems[i].cost.toLocaleString('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 2, maximumFractionDigits: 2 })}`,
            colSpan: 2,
            rowSpan: 1,
            styles: { fontStyle: 'bold', halign: 'center' }
          }
        ]
      ],
      didDrawPage: data => {
        // manually reduce the margin of the table (except last table)
        if (i < parsedItems.length - 1) {
          data.cursor.y = data.cursor.y - 20
        }
        data.doc.totalPagesCounter += data.table.pageStartY === 0 ? 1 : 0 // counter + 1 if table draw on new page
      }
    })
  }

  // print total
  officeCopy.autoTable({
    theme: 'striped',
    margin: {
      left: 36,
      top: 24,
      bottom: 24,
      right: 36
    },
    head: [
      ['SUB-TOTAL', 'HANDLING FEE', 'DEALER TOTAL']
    ],
    bodyStyle: {
      bold: true
    },
    body: [
      [
        `${subTotal.toLocaleString('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 2, maximumFractionDigits: 2 })}`,
        `${parseFloat(projectInfo.handlingFee).toLocaleString('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 2, maximumFractionDigits: 2 })}`,
        `${(subTotal + parseFloat(projectInfo.handlingFee)).toLocaleString('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
      ]
    ],
    didDrawPage: data => {
      data.doc.totalPagesCounter += data.table.pageStartY === 0 ? 1 : 0 // counter + 1 if table draw on new page
    }
  })

  // print footer
  for (let i = 1; i <= officeCopy.totalPagesCounter; i++) {
    officeCopy.setPage(i)
    officeCopy.setTextColor('#333333').setFontSize(8).setFontStyle('italic').text(
      `Exported By ${userInfo.name.first} ${userInfo.name.last} @ ${currentTime.toLocaleDateString('en-US')} [Page ${i} of ${officeCopy.totalPagesCounter}]`,
      306, 756,
      {
        align: 'center',
        maxWidth: 540
      }
    )
  }

  // upload for share
  let filename = `${projectInfo.name} - Office.pdf`
  let blob = officeCopy.output('blob', { filename })
  let uploadResult = await firebaseService.uploadExportedFile(blob, filename)
  console.log(uploadResult)
  // print share qr-code on file if upload success
  if (uploadResult.success) {
    let qrCodeDataUrl = await linkToQRCode(uploadResult.url)
    console.log(qrCodeDataUrl)
    if (linkToQRCode) {
      officeCopy.setPage(1)
      officeCopy.addImage(qrCodeDataUrl, 'PNG', 500, 115, 80, 80)
      console.log('Image added')
    }
  }

  if (!directDownload) {
    officeCopy.output('dataurlnewwindow', { filename })
  } else {
    officeCopy.save(filename)
  }
}

async function saveInstallerCopy (projectInfo, userInfo, items, directDownload) {
  console.log('run function')
  // parse items data for use
  let necessaryFields = ['qty', 'rl', 'productInfo', 'size', 'fabric', 'specialNote']
  let parsedItems = items.map(item => {
    let parsedItem = {}
    for (let field of necessaryFields) {
      parsedItem[field] = getValue(item, field)
    }
    return parsedItem
  })

  let installerCopy = new jsPDF({   // eslint-disable-line
    orientation: 'p',
    unit: 'pt',
    format: 'letter' // letter(612x792pt) with v-margin = 36, h-margin = 36
  })
  installerCopy.totalPagesCounter = 1 // first page has no hook to auto add, so start count from 1

  // print company logo
  installerCopy.addImage(
    'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMAAAADACAMAAABlApw1AAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAMAUExURcAYKuitsvq/wsEaLJWWmpSVmdLT1e4UH////9PU1u8aJM3O0KChpe4UHukZIsgeLv7+/+4THr8XKcAXKb8YKf79/ZSWmdXW1/z8/b8YKv/+/+/v8O4VH+4XIPX29vr7+/f39/v8/PDx8dfX2ejo6ZaXm/r6+peYnL8XKPn5+d3e397f4P/9/tbW2J2eopqbnuPk5dna3O4ZIvT09fj4+Ozt7fHy8u4bJO8eJ+nq6/75+sUuPuvs7OTl5u7u7/719cAZK+Li4+Dh4qChpOXm5/A/Rufn6P329//8/NjZ2v7y8v/7+9vc3cLCxdna2/q/wbi5u8QnN/TZ3P74+NTV1u4VIPefo/Nla8MkNfrHyPA1PfV7gPvz9NPU1sIfMPApMvLz8+8hKvAtNcfIydzd3tVpdaWmqfvw8bGytaqrrb6/we/Cxsk+TMEeLfJQVpudoNl1f/3q6/AxOe/GyuamrPNrcru8vqGiptFZZd2Gj/m0t9/g4v3m59DR0sAaLLW2uK2usbO0tqanqvzT1KOkp8IhMpiZncc0Q/zd3sAZKvaQlOy5vvaFivzX2fHO0szNztfY2cg6SfaKjtduef78/OKWnc5RXsrLzfR0eemus/JdY/ijpstCUP3g4fvOz/jo6tRibfvKzOCOlvaOkeu2vPfi5fFUW85OW+GTmvPU19l7hPFMU9JdaM1LV/3t7ffm6KytsPza3PPR1PXe4P7w8OWjqveVmeSdpMEbLfm3uvJXXd6Lk/vQ0u29wtDQ0frCxPq6vfFJUPRwdcstO9Jeavnt7stGU/imqvBGTvirrv7t7rCws/NiaPDMz8k4Ru8jLfrv8PBETPmvsuObou8nLv3j5Pfl59yCi9dye+Wgp8XGyM9TYOeqsKeprPA4QMYyQfR3fPebn/bf4fXf4fR1e/eYnPm3udt+h9p+h+/JzPioq/JdZPWBhemyt+skLdjY2fmwsu2+w+8UHuwpM/NobtuCivaVmfWBhv3h4uy7wPnr7PeanumxtsQrOtLS1OsWIDeJB+wAAAdiSURBVHja7dp3VFNXHAfwZ83gFaPJy0toTBhhBJBNAsgKIEsFBWSJcBAQVMQNuMUFaq1a3Na9917VurV1Dxy1Tuzeu7W1dpzeF1FA1ssLWef8vodwOPz1/eS+m/fuvcEszDwYAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFATvjRCYc4AVdTE8sQQvrkC3lD7cCwj2e0sbcwSwFd2wTm4ZTu22OlyhMj8AIrASg5HA2Cx2MN6SM0MwLfPxzXRAFCmeriaE0DlncKpD2A7T3LkmwtA7ueD1/R/CWCJxZFLlGYB4CvH47V5CUCDwNrjJjd9gMLRgdM4ABG8BqlNHCCS5uP1Ug+A0p+jMmWATUQKp3kA23lKFN9UAfKQbvireRWACJ79ckwSwM9xw3EaAJTCeFvTA7jGOHDoAsReo/xMDCCSxuONplEAuo5GT7QzJUDDydsCgCV2GugtMhWAbWAl3lSaAqAM6+FvEgC+fyecwwTAZj3qpjA+QBXlgTeTZgCIMD0xkG9cgFztg+OMASiRb9sYEfB80aUTgM2aPF5uLIDCsbKF+i0DdF6uYTp89OfjLfanAaCe8KxcDQ+w805puT5NgC7LNYYAtOiiU58mgHrCY7pcYwSgntvo9acLYIlZe/LlhgI08dymE4Dxcg1jMHnjcdr9tQCgUSj/T6V/AHpuw7WINgBquRbK1y/ANqSSw9EbgJrM93P0CGh80dWaAGq55mOrL4AqyoGjfwDba5Q2G/L0ASK1D651fwYA9Ik6+oRd6wOUESna12cEoJ7w6G/I0wTYBmo5eXUCaPOERwvwcrPcYABqQ95B0VoAVSijq0dHANuZ1nKtZQBadDGurwsAzebIJTY6A2gsuvQGoJZrLW7IY1ptlhsYoHnCk+oAaLBZbnAAtVzDXZkCqP02DsdoADGLzWajl9OUUBEjgFwdExXq3WW8W6d4H59ulQ4eVikoOJoSnDrBNS/Nfxku6qmIUdAlz2Y5OTlPn+7l5RlZPvVR4Z7LkxIH9bh/H7fRYRLzRSKR3FbhqrKzUeb4S6Vqv0DHmFDviC5unfLje/asdLCyskpJoTcCbPaLXyioqdcwT8/I0f0LJ18eOCVxVI9+SyxP4A7xEaGOgX5Se6WNq8JWLuczn8Tuce7uzcD4GperinLZI1dIYEyUd82A9axEA+ZBjZflaCdnJ2fUNLK8/9TCyQMnJY5C7+mSE7hHt/zxoYF+aql/DmoqF/GbbOqO3kJGgGnppZnr/15+M2HttL1Pd3UPS3anc9NGLgRTIZcyx14qDfnJqqdbRJRjiNpfqbRTKWxFNG5O7kGxWVW79/faV/TPw3tbntwtKGYESPDlyXhcmXXn3Nt51Te2b7qy9M/5f5wfl5AxbeWEXd2Tu3ZsxYMi96Csqmcbe10t+qvNrXVjtxXseLBz8ON/kyoOEy4kSUjaMAK85st9EZ4AhcflcVN9fQNy+46sjt6+7PczmevTLo5LWLX36YRLYXFd3bUqLFoYW7X6zv6tRRveKVn05O6CNYtXDL4W3Ds7u204hiKkgr1IGUPA69wmQlnQj8wapfP1vnnVFzYtS186+1Dat0cyjs1ZOeJAWHJcg3tKcmzWBxt7bb16vM3BW+u2FawZs3nw4+CkinCSlKA32YUgiNrGr6RtawPqhYdCDRD1h3UA8vSJPj10WWnm7FlpP586uWpu8S8bShYd/Wg4anxuXnBS7+wyqqpQiBpLSKFQggoiAoZJMMw4gIbj8zw8a2vfgM6/na0YUhYuIUghVu+q0CoGBtREJpNxub+270CQpJAkMV1iHMDztO8gwXSOcQEYAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAB2pw13PkAd3Vj/eLbMxYUwP4BAwLXOrX7v+/Nr9/1wdM2KpMMYJjQLgEymOSpD3TOXr51Qc7Ic9Gxfm7HvD04qo87ySFMGCHi81Nw+mzKXZ3wY9uqpa/LquRpFOIODMkMAeDxuaueRQz9Oy3ga1vSJcezquQ/H7rjW+00JQRJCTGIiAHTNoO6fp51cGUbjtLtj0O6rJV+NmddbQrgIjQ3gocmKui/9JGFmd61O6i1i7xSXfI0UmJAQGgeArhlZQN72M19o3b32+waxd745uO3BjAqSIFxIAwIEAkFqQN7p0kOnZh5g2L2uYmPxveGLZ2SHY01O71YDyKhrhheQd6F01pG9unevo8j6tOhdSoHGgiRJiX4AAoHMt++N9FlfzjkQZ6GHiLI+Q4rNwUNIorUB6N6Eukenrx8355JeutcZiwH7jy9asDN4SLiQQA4JqTMAlfe9HZ0+f9y0XXruXmcsBvR6awulIFw0k5spwFfATb0efWX+zWMjgiwMnrgqpCg4F3wYE4YzA2REfzf74ipjdK/NQqRYV7BiAyNA2IhkC5NIUFUW8++NmnwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABgRvkf7Rd/ZmowIeYAAABXelRYdFJhdyBwcm9maWxlIHR5cGUgaXB0YwAAeJzj8gwIcVYoKMpPy8xJ5VIAAyMLLmMLEyMTS5MUAxMgRIA0w2QDI7NUIMvY1MjEzMQcxAfLgEigSi4A6hcRdPJCNZUAAAAASUVORK5CYII=',
    'PNG',
    36, 36,
    48, 48
  )

  // print customer's address
  installerCopy.autoTable({
    startY: 24,
    theme: 'plain',
    margin: {
      left: 100,
      top: 0,
      bottom: 0,
      right: 36
    },
    body: [
      [
        {
          content: 'Ship To: ',
          styles: {
            fontStyle: 'bold',
            cellPadding: 2,
            halign: 'right'
          }
        },
        {
          content: `${projectInfo.shipTo}`,
          styles: {
            cellPadding: 2,
            halign: 'left'
          }
        }
      ],
      [
        {
          content: 'Company Name: ',
          styles: {
            fontStyle: 'bold',
            cellPadding: 2,
            halign: 'right',
            cellWidth: 'wrap'
          }
        },
        {
          content: `${projectInfo.companyName}`,
          styles: {
            cellPadding: 2,
            halign: 'left'
          }
        }
      ],
      [
        {
          content: 'Contact: ',
          styles: {
            fontStyle: 'bold',
            cellPadding: 2,
            halign: 'right'
          }
        },
        {
          content: `${projectInfo.contact}`,
          styles: {
            cellPadding: 2,
            halign: 'left'
          }
        }
      ],
      [
        {
          content: 'Street: ',
          styles: {
            fontStyle: 'bold',
            cellPadding: 2,
            halign: 'right'
          }
        },
        {
          content: `${projectInfo.street}Test Very Very Very Very Very Very Very Very Very Very Long Address`,
          styles: {
            cellPadding: 2,
            halign: 'left'
          }
        }
      ],
      [
        {
          content: 'City: ',
          styles: {
            fontStyle: 'bold',
            cellPadding: 2,
            halign: 'right'
          }
        },
        {
          content: `${projectInfo.city}`,
          styles: {
            cellPadding: 2,
            halign: 'left'
          }
        }
      ],
      [
        {
          content: 'State: ',
          styles: {
            fontStyle: 'bold',
            cellPadding: 2,
            halign: 'right'
          }
        },
        {
          content: `${projectInfo.state}`,
          styles: {
            cellPadding: 2,
            halign: 'left'
          }
        }
      ],
      [
        {
          content: 'Phone: ',
          styles: {
            fontStyle: 'bold',
            cellPadding: 2,
            halign: 'right'
          }
        },
        {
          content: `${projectInfo.phone}`,
          styles: {
            cellPadding: 2,
            halign: 'left'
          }
        }
      ],
      [
        {
          content: 'Zip: ',
          styles: {
            fontStyle: 'bold',
            cellPadding: 2,
            halign: 'right'
          }
        },
        {
          content: `${projectInfo.zip}`,
          styles: {
            cellPadding: 2,
            halign: 'left'
          }
        }
      ],
      [
        {
          content: 'Ship-Via: ',
          styles: {
            fontStyle: 'bold',
            cellPadding: 2,
            halign: 'right'
          }
        },
        {
          content: `${projectInfo.shipVia}`,
          styles: {
            cellPadding: 2,
            halign: 'left'
          }
        }
      ]
    ]
  })

  // print order Info
  let currentTime = new Date()
  installerCopy.autoTable({
    startY: 200,
    theme: 'striped',
    margin: {
      left: 36,
      top: 24,
      bottom: 24,
      right: 36
    },
    head: [
      ['QN', 'DATE', 'SM', 'PO']
    ],
    bodyStyle: {
      bold: true
    },
    body: [
      [
        `${projectInfo.qn || 'N/A'}`,
        `${currentTime.toLocaleDateString('en-US')}`,
        `${projectInfo.sideMark || 'N/A'}`,
        `${projectInfo.purchaseOrder || 'N/A'}`
      ]
    ]
  })

  // print item list
  for (let i = 0; i < parsedItems.length; i++) {
    installerCopy.autoTable({
      theme: 'grid',
      margin: {
        top: 0,
        bottom: 36,
        left: 48,
        right: 48
      },
      tableWidth: 540,
      styles: {
        cellWidth: 50,
        overflow: 'ellipsize',
        fontSize: 10,
        cellPadding: 2,
        minCellWidth: 53,
        minCellHeight: 12,
        valign: 'middle'
      },
      pageBreak: 'avoid',
      body: [
        Array.from(new Array(10), () => {
          return {
            content: ' ',
            cellWidth: 54,
            styles: {
              lineWidth: 0
            }
          }
        }),
        [
          { // Item index
            content: `${i + 1} / ${parsedItems.length}`,
            colSpan: 2,
            rowSpan: 2,
            styles: { fontSize: 18, valign: 'middle', halign: 'center' }
          },
          {
            // RL Title
            content: 'RL',
            colSpan: 1,
            rowSpan: 1,
            styles: { fontStyle: 'bold', halign: 'center' }
          },
          {
            // RL Content
            content: `${parsedItems[i].rl}`,
            colSpan: 3,
            rowSpan: 1
          },
          {
            // SZ Title
            content: 'SZ',
            colSpan: 1,
            rowSpan: 1,
            styles: { fontStyle: 'bold', halign: 'center' }
          },
          {
            // RL Content
            content: `${parsedItems[i].size}`,
            colSpan: 3,
            rowSpan: 1
          }
        ],
        [
          {
            // P Title
            content: 'Product',
            colSpan: 1,
            rowSpan: 1,
            styles: { fontStyle: 'bold', halign: 'center' }
          },
          {
            // P Content
            content: `${parsedItems[i].productInfo}`,
            colSpan: 7,
            rowSpan: 1
          }
        ],
        [
          {
            // Qty Title
            content: 'Qty.',
            colSpan: 1,
            rowSpan: 1,
            styles: { fontStyle: 'bold', halign: 'center' }
          },
          {
            // Qty Content
            content: `${parsedItems[i].qty}`,
            colSpan: 1,
            rowSpan: 1,
            styles: { halign: 'center' }
          },
          {
            // Fabric Title
            content: 'Fabric',
            colSpan: 1,
            rowSpan: 1,
            styles: { fontStyle: 'bold', halign: 'center' }
          },
          {
            // Fabric Content
            content: `${parsedItems[i].fabric}`,
            colSpan: 7,
            rowSpan: 1
          }
        ],
        [
          {
            // Cost (Not display in installer copy)
            content: ' ',
            colSpan: 2,
            rowSpan: 1,
            styles: { fontStyle: 'bold', halign: 'center' }
          },
          {
            // Special Note
            content: `Special Note: ${parsedItems[i].specialNote}`,
            colSpan: 8,
            rowSpan: 2,
            styles: { fontStyle: 'bold', valign: 'top' }
          }
        ],
        [
          {
            // Ext (Not display in installer copy)
            content: '',
            colSpan: 2,
            rowSpan: 1,
            styles: { fontStyle: 'bold', halign: 'center' }
          }
        ]
      ],
      didDrawPage: data => {
        // manually reduce the margin of the table (except last table)
        if (i < parsedItems.length - 1) {
          data.cursor.y = data.cursor.y - 20
        }
        data.doc.totalPagesCounter += data.table.pageStartY === 0 ? 1 : 0 // counter + 1 if table draw on new page
      }
    })
  }

  // print footer
  for (let i = 1; i <= installerCopy.totalPagesCounter; i++) {
    installerCopy.setPage(i)
    installerCopy.setTextColor('#333333').setFontSize(8).setFontStyle('italic').text(
      `Exported By ${userInfo.name.first} ${userInfo.name.last} @ ${currentTime.toLocaleDateString('en-US')} [Page ${i} of ${installerCopy.totalPagesCounter}]`,
      306, 756,
      {
        align: 'center',
        maxWidth: 540
      }
    )
  }

  // upload for share
  let filename = `${projectInfo.name} - Installer.pdf`
  let blob = installerCopy.output('blob', { filename })
  let uploadResult = await firebaseService.uploadExportedFile(blob, filename)
  console.log(uploadResult)
  // print share qr-code on file if upload success
  if (uploadResult.success) {
    let qrCodeDataUrl = await linkToQRCode(uploadResult.url)
    console.log(qrCodeDataUrl)
    if (linkToQRCode) {
      installerCopy.setPage(1)
      installerCopy.addImage(qrCodeDataUrl, 'PNG', 450, 90, 80, 80)
      console.log('Image added')
    }
  }

  if (!directDownload) {
    installerCopy.output('dataurlnewwindow', { filename })
  } else {
    installerCopy.save(filename)
  }
}

function getP (item) {
  let type = item.detail.templateId
  switch (type) {
    case 'roller_shade':
      return `${getValue(item, 'operatingSystem')} ${getValue(item, 'fabric')}`
    case 'honey_combs':
      return `${getValue(item, 'operatingSystem')} ${getValue(item, 'fabricType')} ${getValue(item, 'fabric')}`
    case 'vertical_blinds':
      return `${getValue(item, 'operatingSystem')} ${getValue(item, 'vanes')}`
    case 'wood_blind':
      return `${getValue(item, 'operatingSystem')} ${getValue(item, 'tilt')} ${getValue(item, 'slats')} ${getValue(item, 'color')}`
    case 'drapery':
      return `${getValue(item, 'operatingSystem')} ${getValue(item, 'fabric')}`
    default:
      return 'N/A'
  }
}

async function linkToQRCode (text) {
  try {
    let dataUrl = await QRCode.toDataURL(text)
    return dataUrl || null
  } catch (err) {
    console.warn(err)
    return null
  }
}
